export default function SectionTitle({
  subtitle,
  title
}) {
  return (
    <div className="mb-14">

      <span className="uppercase tracking-[4px] text-blue-400 text-sm">

        {subtitle}

      </span>

      <h2 className="text-5xl font-bold mt-3">

        {title}

      </h2>

    </div>
  );
}